import { findParentNodeOfType, findSelectedNodeOfType } from '@atlaskit/editor-prosemirror/utils';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
export var getMaybeLayoutSection = function getMaybeLayoutSection(state) {
  var _state$schema$nodes = state.schema.nodes,
    layoutSection = _state$schema$nodes.layoutSection,
    layoutColumn = _state$schema$nodes.layoutColumn,
    selection = state.selection;
  var isLayoutColumn = editorExperiment('advanced_layouts', true) && findSelectedNodeOfType([layoutColumn])(selection);

  // When selection is on layoutColumn, we want to hide floating toolbar, hence don't return layoutSection node here
  return isLayoutColumn ? undefined : findParentNodeOfType(layoutSection)(selection) || findSelectedNodeOfType([layoutSection])(selection);
};